export interface UploadResumeState {
  offset: number;
  fileSize: number;
  receivedBytes: number;
  nextPart: number;
}

export interface UploadResumePlan {
  partNo: number;
  reconcileBytes?: number;
}

/**
 * Build a resume plan from the two authorities involved in a resumable upload: GCS owns the committed
 * byte offset, while the submission row owns the next progress-report sequence number. A committed
 * GCS offset may be ahead when the tab closed after a PUT succeeded but before `report-progress`
 * reached the backend; that gap is repaired with one cumulative progress report.
 */
export function planUploadResume(state: UploadResumeState): UploadResumePlan {
  const { offset, fileSize, receivedBytes, nextPart } = state;
  const values = [offset, fileSize, receivedBytes, nextPart];
  if (values.some((value) => !Number.isSafeInteger(value) || value < 0)) {
    throw new Error('Upload resume state is invalid');
  }
  if (offset > fileSize) throw new Error('GCS upload offset exceeds the selected file size');
  if (receivedBytes > fileSize)
    throw new Error('Backend upload progress exceeds the selected file size');
  if (offset < receivedBytes) throw new Error('GCS upload offset is behind backend progress');

  return {
    partNo: nextPart,
    reconcileBytes: offset > receivedBytes ? offset : undefined,
  };
}
